import ApiConstants from '../../../constants/ApiConstants';
import Utility from '../../../utility/Utility';
import http from "../../../http";
import moment from 'moment'


class INTaxService {
    static apiConfig;
    static getTaxESI() {
        if (Utility.isEmpty(this.apiConfig)) {
            // this.apiConfig = defaultConfig;
        }
        const url = ApiConstants.URL.COMPLIANCE.IN.GET_TAX_ESI;
        return http
            .get(
                `${url}`
            )
            .catch((err: any) => {
                console.error('Error loading payrolls: ', err);
                return Promise.reject(err);
            });
    }
    static getTaxDetail() {
        if (Utility.isEmpty(this.apiConfig)) {
            // this.apiConfig = defaultConfig;
        }
        const url = ApiConstants.URL.COMPLIANCE.IN.GET_IN_TAX_DETAIL;
        return http
            .get(
                `${url}`
            )
            .catch((err: any) => {
                console.error('Error loading payrolls: ', err);
                return Promise.reject(err);
            });
    }
    static saveTaxDetail(data) {
        if (Utility.isEmpty(this.apiConfig)) {
            // this.apiConfig = defaultConfig;
        }
        const url = ApiConstants.URL.COMPLIANCE.IN.GET_IN_TAX_DETAIL;
        return http
            .post(
                `${url}`,data
            )
            .catch((err: any) => {
                console.error('Error loading payrolls: ', err);
                return Promise.reject(err);
            });
    }
    static updateTaxDetail(data) {
        if (Utility.isEmpty(this.apiConfig)) {
            // this.apiConfig = defaultConfig;
        }
        const url = ApiConstants.URL.COMPLIANCE.IN.GET_IN_TAX_DETAIL;
        return http
            .put(
                `${url}`,data
            )
            .catch((err: any) => {
                console.error('Error loading payrolls: ', err);
                return Promise.reject(err);
            });
    }
}

export default INTaxService;
